<template>
	<div>
		<nav-bar-home></nav-bar-home>
		<div>
			<dashboard-stats></dashboard-stats>

		</div>
		<div >
			<div class="container-fluid">
				<section class="cart-main" style="min-height:auto;">
				<main>
					<h3 class="acc-title lg">MY ORDERS</h3>
				</main>
				<!--Cart Item-->
				<p class="visible-xs mobile-cart-title">There are 2 items in your cart.</p>
				<div class="jobs-tabs" v-if="selectedItem">
					<!-- <button class="btn btn-danger btn-sm" style="float: left;" > Back </button> -->
					<!-- <br> -->
					<!-- <br> -->
					<div class="tabs">
						<span v-if="!user.isSubChildUser" class="tab" :class="{ 'selected': tab == 0 }"
							@click="tab = 0">DETAILS</span>
						<span class="tab" :class="{ 'selected': tab == 1 }" @click="tab = 1">STATUS</span>
						<span class="tab" :class="{ 'selected': tab == 6 }" @click="tab = 6">Product / Service Detail</span>
						<span v-if="viewArtWorkCondi(selectedItem)" class="tab" :class="{ 'selected': tab == 2 }" @click="tab = 2">ARTWORK</span>

						<!-- <span v-if="selectedItem.items[0].product.product.nonPrint != 'Non Print'" class="tab"
							:class="{ 'selected': tab == 2 }" @click="tab = 2">ARTWORK</span> -->

						<span class="tab" :class="{ 'selected': tab == 3 }" @click="tab = 3">BILLING & DELIVERY</span>
						<span class="tab" :class="{ 'selected': tab == 4 }" @click="tab = 4">Notifications</span>
						<span class="tab" :class="{ 'selected': tab == 5 }" @click="tab = 5">Order History</span>
						<span class="tab" @click="refresh">BACK</span>
					</div>
					<div v-if="tab == 5">
						<p class="item-details head"> <span class="first"> <b> Order History </b> </span> </p>
						<template v-if="orderActivs[selectedItem['orderNumber']]?.length > 0">
							<table>
								<tr v-for="ordAct in orderActivs[selectedItem['orderNumber']]" :key="ordAct._id">
								<td>
									<p class="item-details sec">
										<span class="first">
											<b>
												{{
													(selectedItem.items[0].product &&
														selectedItem.items[0].product.product.nonPrint == 'Non Print' &&
														ordAct.title == 'Artwork Approved') ||
														(selectedItem.items[0].quote_id &&
															selectedItem.items[0].quote_id.productProcess == 'Non Print' &&
															ordAct.title == 'Artwork Approved')
														? 'Order Approved'
														: ordAct.title
												}}
											</b>
										</span>
										<span class="second">
											<!-- {{
												(selectedItem.items[0].product &&
													selectedItem.items[0].product.product.nonPrint == 'Non Print' &&
													ordAct.title == 'Artwork Approved') ||
													(selectedItem.items[0].quote_id &&
														selectedItem.items[0].quote_id.productProcess == 'Non Print' && ordAct.title
														== 'Artwork Approved')
													? 'Order Approved'
													: ordAct.title
											}}
											at --> {{ formatDateTime(ordAct.createdAt) }}
										</span>
									</p>
								</td>
							</tr>
							</table>
						</template>
						<template v-else>
							<table>
								<tr>
								<td>
									<p class="item-details sec">
										<span class="first"><b>Status:</b></span>
										<span class="first"><b>{{ selectedItem['status'] }}</b></span>
									</p>
								</td>
							</tr>
							</table>
						</template>
					</div>
					<div v-if="tab == 4">
						<div v-if="selectedItem.isSubChildID.length > 0 && selectedItem.isSubChildID[0] != ''">
							<h3 class="jobs-email">Email Configured for Notifications : <b>{{
								selectedItem.isSubChildID[0].email }}</b>
							</h3>
							<h3 class="jobs-email">Email Configured for Parent Notifications : <b>{{
								selectedItem.orderEmail }}</b> </h3>
						</div>
						<div v-else>
							<h3 class="jobs-email">Email Configured for Notifications : <b>
									{{ selectedItem.user.email ? selectedItem.user.email : user.email }}</b> </h3>
						</div>
						<!-- <div  v-if="selectedItem.user.isSubChildUser ">
									<h3>Email Configured for Parent Notifications : <b>{{ user.email }}22</b> </h3>
								</div> -->
						<div v-if="!cEmail">
							<!-- <h4 > <button class="btn btn-primary" style="float: right;" @click="changeEmail()"> Change </button> </h4> -->
						</div>
						<div v-else>
							<label for="">Please Provide a Valid Email Address</label>
							<input type="email" name="" id="" v-model="cEmailValue" class="form-control">
							<button class="btn btn-primary" @click="updateCEmail()"> Update Email </button>
							<span class="text-danger" v-if="cEmailError.length">{{ cEmailError }}</span>
							<span class="text-success" v-if="cEmailSuccess.length"> {{ cEmailSuccess }}</span>
						</div>
					</div>
					<div v-if="tab == 0">
						<p class="item-details"> <span class="first"> <b> ID </b> </span> <span class="second"> {{
							selectedItem.orderNumber }}</span> </p>
						<p class="item-details sec"> <span class="first"> <b> Status </b> </span> <span class="second">
								{{
									selectedItem.status }}</span> </p>
						<p class="item-details"> <span class="first"> <b> Payment status </b> </span> <span class="second"> {{
							(selectedItem.isOrderPaid) ? "PAID" : "NOT PAID" }}</span> </p>
						<p class="item-details sec"> <span class="first"> <b> Payment Method </b> </span> <span
								class="second"> {{
									selectedItem.paymentMethod }}</span> </p>
						<!-- <p class="item-details"> <span class="first"> <b> Shipping Method </b> </span> <span
								class="second">
								{{ selectedItem.shippingMethod }}</span> </p> -->
						<p class="item-details sec"> <span class="first"> <b> Product </b> </span>
							<span class="second" v-if="selectedItem.isOrderCustom"> Custom Order</span>
							<span class="second" v-else> {{ selectedItem.items[0].product ?
								selectedItem.items[0].product.productName :
								selectedItem.items[0].quote_id.quotesProduct }}</span>
						</p>
						<!-- <p class="item-details"> <span class="first"> <b> Description </b> </span>
							<span class="second" v-if="selectedItem.isOrderCustom"> Custom Order</span>
							<span class="second" v-else> {{ selectedItem.items[0].product ?
								selectedItem.items[0].product.productMktDesc :
								selectedItem.items[0].quote_id.suppliersDesription }}</span>
						</p> -->
						<p class="item-details sec" v-if="selectedItem.items[0].quantity.quantity > 0"> <span class="first"> <b> Quantity </b> </span> <span
								class="second"> {{
									selectedItem.items[0].quantity.quantity }}</span> </p>
						<br>
						<div
							v-if="selectedItem.items[0].discountPromoCode || selectedItem.items[0].discountPCP || selectedItem.items[0].spendDiscount">

							<p class="item-details head"> <span class="first"> <b> Discounts: </b> </span> </p>
							<p class="item-details"> <span class="first"> <b> Promotion <i
											v-if="selectedItem.items[0].discountPromoCode">({{
												selectedItem.items[0].discountPromoCode }}%)</i> </b> </span>
								&euro; <span class="second"> {{ $roundCurrency(selectedItem.items[0].discountPromoCodeAm).toFixed(2) }}</span>
							</p>
							<p class="item-details"> <span class="first"> <b> Original Product Price <i
											v-if="selectedItem.items[0].quantity.sellingProductPrice"></i> </b> </span>
								&euro; <span class="second"> {{ $roundCurrency(selectedItem.items[0].quantity.sellingProductPrice).toFixed(2) }}</span>
							</p>
							<p class="item-details sec" v-if="selectedItem.items[0].discountPCP && selectedItem.items[0].discountPCP != 0">
								<span class="first"> <b> Preferential <i
									v-if="selectedItem.items[0].discountPCP">({{
										selectedItem.items[0].discountPCP
									}}%)</i> </b> </span>
								<span class="second"> {{ $roundCurrency(selectedItem.items[0].discountPCPAm).toFixed(2) }}</span>
							</p>
							<!-- <p class="item-details"> <span class="first"> <b> Spends <i
											v-if="selectedItem.items[0].spendDiscount">({{
												selectedItem.items[0].spendDiscount }}%)</i> </b> </span>
								<span class="second"> {{ selectedItem.items[0].spendDiscountAm }}</span>
							</p> -->
						</div>
						<br>
						<p class="item-details head"> <span class="first"> <b> Totals: </b> </span> </p>
						<p class="item-details"> <span class="first"> <b> Subtotal </b> </span>
							&euro; <b>{{ $calculateSubtotal(selectedItem.items[0].quantity.sellingProductPrice, [
								selectedItem.items[0].discountPromoCodeAm,
								selectedItem.items[0].discountPCPAm,
								selectedItem.items[0].spendDiscountAm,
							]).toFixed(2) }} </b>
								
								<span class="second color-red" v-if="selectedItem.status === 'Order Cancelled' && hasCompletedAndShipped(orderActivs[selectedItem['orderNumber']] || [])"> <b>( -{{$LFT(selectedItem.items[0].quantity.sellingProductPrice - (
								selectedItem.items[0].discountPromoCodeAm + selectedItem.items[0].discountPCPAm +
								selectedItem.items[0].spendDiscountAm)) }} )</b> </span>
						</p>
						<p class="item-details">
							<span class="first"> <b> VAT<template v-if="selectedItem.items[0].product"> ({{selectedItem.items[0].product.product.supplierVAT}}%)</template> </b> </span>
							&euro; 
							<b>{{ Number(selectedItem.items[0].vat).toFixed(2) }}</b>


							<!-- old vat calcuation -->
							<!-- <b>{{ $LFT(((selectedItem.items[0].quantity.sellingProductPrice - (
								selectedItem.items[0].discountPromoCodeAm + selectedItem.items[0].discountPCPAm +
								selectedItem.items[0].spendDiscountAm)) * selectedItem.items[0].vat) / 100) }} 
							</b> -->

							<span class="second color-red" v-if="selectedItem.status === 'Order Cancelled' && hasCompletedAndShipped(orderActivs[selectedItem['orderNumber']] || [])"> <b>( -{{ $LFT(((selectedItem.items[0].quantity.sellingProductPrice - (
									selectedItem.items[0].discountPromoCodeAm + selectedItem.items[0].discountPCPAm +
									selectedItem.items[0].spendDiscountAm)) * selectedItem.items[0].vat) / 100) }} )</b> 
							</span>
						</p>
						<p class="item-details sec"> <span class="first"> <b> TOTAL </b> </span>
							&euro; 
								<!-- Old way of getting Total value -->
								<!-- <b>					
									{{ $LFT(
										(selectedItem.items[0].quantity.sellingProductPrice - (
											selectedItem.items[0].discountPromoCodeAm + selectedItem.items[0].discountPCPAm +
											selectedItem.items[0].spendDiscountAm))
										+
										(((selectedItem.items[0].quantity.sellingProductPrice - (
											selectedItem.items[0].discountPromoCodeAm + selectedItem.items[0].discountPCPAm +
											selectedItem.items[0].spendDiscountAm)) * selectedItem.items[0].vat) / 100)) 
									}} 
								</b> -->
								<b>{{ computeItemTotal(selectedItem.items[0]) }}</b>

								<span class="second color-red" v-if="selectedItem.status === 'Order Cancelled' && hasCompletedAndShipped(orderActivs[selectedItem['orderNumber']] || [])"> <b> ( -{{ $LFT(
								(selectedItem.items[0].quantity.sellingProductPrice - (
									selectedItem.items[0].discountPromoCodeAm + selectedItem.items[0].discountPCPAm +
									selectedItem.items[0].spendDiscountAm))
								+
								(((selectedItem.items[0].quantity.sellingProductPrice - (
									selectedItem.items[0].discountPromoCodeAm + selectedItem.items[0].discountPCPAm +
									selectedItem.items[0].spendDiscountAm)) * selectedItem.items[0].vat) / 100)) }} )
								</b>

							</span>
						</p>

					</div>
					<div v-if="tab == 1">
						<p class="item-details head"> <span class="first" style="width: 105px;"> <b> STATUS </b> </span> <span class="second">
								{{ selectedItem.status }} </span> </p>
					</div>
					<div v-if="tab == 2">
						<h3 class="title">Artworks</h3>
						<div v-for="it in selectedItem.items" :key="it._id">
							<p class="subtitle">{{ it.product ? it.product.productName : it.quote_id.quotesProduct }}
							</p>
							<a id="downloadLink" style="display: none;"></a>
							<span v-if="it.artwork && it.artwork.length">
								<a :href="$store.state.URL + '/uploads/artworks/' + (selectedItem.artworkProofing === 'Yes' ? it.artwork : (it.supplierArtwork) ? it.supplierArtwork : it.artwork)" class="text-danger"
									target="_blank"><b>View
										Artwork</b></a>
								<span v-if="selectedItem.artworkApproved" class="link text-danger"
									@click="downloadFile($store.state.URL + '/uploads/artworks/' + (selectedItem.artworkProofing === 'Yes' ? it.artwork : (it.supplierArtwork) ? it.supplierArtwork : it.artwork), (selectedItem.artworkProofing === 'Yes' ? it.artwork : (it.supplierArtwork) ? it.supplierArtwork : it.artwork))">
									<b> / Download Artwork</b></span>

							</span>
							<span v-else> <b>Artwork Not Provided</b> </span>
							<div v-if="!selectedItem.artworkApproved">
								<div
									v-if="selectedItem.status == 'Awaiting Artwork Upload' || selectedItem.status == 'Artwork Rejected'">
									<h3 class="title">Upload Artwork File</h3>
									<!-- <p class="p-name subtitle">{{ it.product.productName }}</p> -->
									<div v-if="it.artworkSamples.length">
										<div v-for="(sample, index) in it.artworkSamples" :key="sample">
											<a style="color: blue;"
												:href="$store.state.URL + '/uploads/artworks-attach/' + sample"
												target="_blank" rel="noopener noreferrer">
												<b>{{ index + 1 }}: {{ sample }}</b>
											</a>
										</div>
									</div>
									<!-- <span v-else> <b>Artwork Samples Not Provided</b> </span> -->
									<!-- <p class="p-title" v-if="selectedItem.artworkComments"> Upload Artwork Sample / Attachment </p> -->
									<p class="p-title" v-if="it.artwork"> Please Upload the Correct Artwork </p>
									<p class="p-title" v-else>
										<b v-if="selectedItem.artworkComment" class="atstatus"> {{
											selectedItem.artworkComment
										}} <br></b>
										<b>Please Upload Artwork</b>
									</p>
									<div class="col-md-12">
										<div class="col-md-6" style="padding:10px;border:2px solid lightgray;width: 301px;">
											<!-- <p> <b>Upload Your Artwork Related Samples and Attachments</b> </p> -->
											<!-- <p>You can email us the artwork to "artwork@discoverprint.ie" after completing the order with order number</p> -->
											<div style="border:1px dotted lightgray;padding:10px;position:relative;">
												<input type="file" name="" id="" class="v-input" @change="handle">

												<img src="/images/download.png" alt="" class="" srcset=""
													style="width:110px;display: block; margin-left:auto; margin-right:auto;">
												<p>Click here to choose the files or drag them here</p>
											</div>
											<div v-if="$store.state.uploadProgress">
												<b>Uploading:</b> <span> {{ $store.state.uploadProgress }}% </span>
											</div>
											<div v-if="allFiles">
												{{ allFiles.name }}
											</div>
										</div>
										<div class="col-md-6">
											<div>
												<span><b>Do you Require an Artwork PDF Proof File?</b></span>
												<br>
												<input type="radio" @change="artworkStatus('Yes')" name="artworkStatus" value="Yes">
												<label>&nbsp;&nbsp;&nbsp;Yes</label>
												<br>
												<input type="radio" @change="artworkStatus('No')" name="artworkStatus" value="No">

												<label>&nbsp;&nbsp;&nbsp;No</label>

											</div>
										</div>
										<!-- <div v-if="it.artwork"><button class="btn btn-upload" v-if="allFiles !== null" @click="startUpload(it)" style="width: 291px;margin: 5px;">Upload</button></div> -->
										<div class="col-md-12" style="margin-bottom: 50px;"> 
											<button class="btn btn-upload btn-success" v-if="allFiles !== null" @click="startUploadArt(it)" style="width: 260px;margin: 5px;">Upload Artwork</button> 
										</div>
									</div>
								</div>
							</div>


						</div>
					</div>
					<div v-if="tab == 3">
						<p class="item-details head"> <span class="first"> <b> Billing </b> </span> </p>
						<p class="item-details sec"> <span class="first"> <b> Business Name </b> </span> <span class="second">
									{{ selectedItem?.user?.accountTitle ?? selectedItem?.isSubChildID?.[0]?.accountTitle }} </span> </p>
						<p class="item-details"> <span class="first"> <b> Address Line 1 </b> </span> <span
								class="second">
								{{ selectedItem.billingAddress.billAddressOne ?
									selectedItem.billingAddress.billAddressOne :
									selectedItem.billingAddress.addressOne }}</span> </p>
						<p class="item-details sec"> <span class="first"> <b> Address Line 2 </b> </span> <span
								class="second"> {{
									selectedItem.billingAddress.billAddressTwo ? selectedItem.billingAddress.billAddressTwo
										:
										selectedItem.billingAddress.addressTwo }} </span> </p>
						<p class="item-details"> <span class="first"> <b> City </b> </span> <span class="second"> {{
							selectedItem.billingAddress.billCity ? selectedItem.billingAddress.billCity :
								selectedItem.billingAddress.city }}</span> </p>
						<p class="item-details sec"> <span class="first"> <b> County </b> </span> <span class="second">
								{{
									selectedItem.billingAddress.billCounty ? selectedItem.billingAddress.billCounty :
										selectedItem.billingAddress.county }} </span> </p>
						<p class="item-details"> <span class="first"> <b> Country </b> </span> <span class="second"> {{
							selectedItem.billingAddress.billCountry ? selectedItem.billingAddress.billCountry :
								selectedItem.billingAddress.country }}</span> </p>
						<p class="item-details sec"> <span class="first"> <b> Post Code </b> </span> <span
								class="second">
								{{ selectedItem.billingAddress.billPostCode ? selectedItem.billingAddress.billPostCode :
									selectedItem.billingAddress.postCode }} </span> </p>

						<div v-if="selectedItem.items[0].quantity.quantity > 0">						
							<p class="item-details head"> <span class="first"> <b> Delivery </b> </span> </p>
							<p class="item-details sec"> <span class="first"> <b> Business Name </b> </span> <span class="second">
									{{ selectedItem?.user?.accountTitle ?? selectedItem?.isSubChildID?.[0]?.accountTitle }} </span> </p>
							<p class="item-details"> <span class="first"> <b> Address Line 1 </b> </span> <span
									class="second">
									{{ selectedItem.deliveryAddress.addressOne }}</span> </p>
							<p class="item-details sec"> <span class="first"> <b> Address Line 2 </b> </span> <span
									class="second"> {{
										selectedItem.deliveryAddress.addressTwo }} </span> </p>
							<p class="item-details"> <span class="first"> <b> City </b> </span> <span class="second"> {{
								selectedItem.deliveryAddress.city }}</span> </p>
							<p class="item-details sec"> <span class="first"> <b> County </b> </span> <span class="second">
									{{
										selectedItem.deliveryAddress.county }} </span> </p>
							<p class="item-details"> <span class="first"> <b> Country </b> </span> <span class="second"> {{
								selectedItem.deliveryAddress.country }}</span> </p>
							<p class="item-details sec"> <span class="first"> <b> Post Code </b> </span> <span
									class="second">
									{{ selectedItem.deliveryAddress.postCode }} </span> </p>
							<p class="item-details"> <span class="first"> <b> Delivery Turnaround </b> </span> <span
									class="second"> {{
										selectedItem.items[0].product ? selectedItem.items[0].product.deliveryTurnaround :
											selectedItem.items[0].quote_id.quantity.deliveryTurnaround }} </span> </p>
						</div>

					</div>

					<div v-if="tab == 6">
						<p class="item-details" > <span class="first"> <b> Name </b> </span> <span class="second">  {{ selectedItem.items[0].product ? selectedItem.items[0]?.product?.productName : selectedItem.items[0]?.quote_id.suppliersDesription }}</span> </p>
						<p v-if="selectedItem.items[0]?.opData?.printed" class="item-details sec"> <span class="first"> <b> Print </b> </span> <span class="second">
								{{ selectedItem.items[0].opData?.printed }}</span> </p>
								<p v-if="selectedItem.items[0].opData?.productPaperSizeFormat" class="item-details"> <span class="first"> <b> Size </b> </span> <span
								class="second">{{ selectedItem.items[0].opData?.productPaperSizeFormat }}</span> </p>
						<p v-if="selectedItem.items[0]?.opData?.productPaperTypeWeight" class="item-details sec"> <span class="first"> <b> Weight </b> </span> <span
								class="second"> {{ selectedItem.items[0].opData?.productPaperTypeWeight }}</span> </p>
						<p v-if="selectedItem.items[0]?.opData?.material" class="item-details"> <span class="first"> <b> Material </b> </span> <span
								class="second">{{ selectedItem.items[0].opData?.material }}</span> </p>
						<p v-if="selectedItem.items[0]?.opData?.lamination" class="item-details sec"> <span class="first"> <b> Lamination </b> </span> <span
								class="second">{{ selectedItem.items[0].opData?.lamination }}</span> </p>
						<p v-if="selectedItem.items[0]?.opData?.foldingOption" class="item-details"> <span class="first"> <b> Folding Options </b> </span> <span
								class="second">{{ selectedItem.items[0].opData?.foldingOption }}</span> </p>
						<p v-if="selectedItem.items[0]?.opData?.bookletType" class="item-details sec"> <span class="first"> <b> Booklet Type </b> </span> <span
								class="second">{{ selectedItem.items[0].opData?.bookletType }}</span> </p>
						<p v-if="selectedItem.items[0]?.opData?.bookletPagination" class="item-details"> <span class="first"> <b> Booklet Pagination </b> </span> <span
								class="second">{{ selectedItem.items[0].opData?.bookletPagination }}</span> </p>	
						<p v-if="selectedItem.items[0]?.quantity.quantity" class="item-details sec"> <span class="first"> <b> Order Quantity </b> </span> <span
								class="second">
								{{ selectedItem.items[0].quantity.quantity }}</span> </p>
						<p class="item-details" v-if="selectedItem.items[0].quantity.quantity > 0"> <span class="first"> <b> Delivery </b> </span> <span
								class="second">
								{{ (selectedItem.items[0]?.product) ? selectedItem.items[0]?.product.deliveryTurnaround : selectedItem.items[0]?.quote_id.deliveryTurnaround }}</span> </p>					
						
						<br>
					</div>
					<!-- {{ selectedItem }} -->
				</div>
				<div v-else>
					<div class="jobs-toolbar">
						<div class="jobs-search">
							<i class="fa fa-search jobs-search-icon" aria-hidden="true"></i>
							<input
								type="text"
								v-model="searchQuery"
								class="jobs-search-input"
								placeholder="Search by Order No, Order Placed By, Branch Location, Description or Status"
							>
							<button v-if="searchQuery" type="button" class="jobs-search-clear" @click="searchQuery = ''" aria-label="Clear search">
								<i class="fa fa-times" aria-hidden="true"></i>
							</button>
						</div>
						<div class="jobs-result-count">
							{{ filteredUsOrders.length }} order{{ filteredUsOrders.length === 1 ? '' : 's' }} found
						</div>
					</div>
					<div class="jobs-table-wrap">
					<table class="table-cart table jobs-table">
						<thead>
						<tr>
							<th style="padding:0px 20px;">Order No.</th>
							<th>Order Summary</th>
							<th>Order Placed By</th>
							<th v-if="showNameColumn">Name</th>
							<th>Branch Location</th>
							<th>Description</th>
							<th>Quantity</th>
							<th>Status</th>
							<th>Ordered</th>
							<th>Action</th>
							<!-- <th>Approved</th> -->
							<!-- <th>Shipping </th> -->
							<!-- <th>Due </th> -->
						</tr>
						</thead>
						<tbody>
						<tr v-if="!paginatedUsOrders.length">
							<td :colspan="showNameColumn ? 10 : 9" class="jobs-no-results">
								<i class="fa fa-inbox" aria-hidden="true"></i>
								No orders match your search.
							</td>
						</tr>
						<tr v-for="order in paginatedUsOrders" :key="order._id" >
							<td class="link" @click="selectedItem = order" style="padding:0px 20px;">{{ order.orderNumber }}</td>

							<td>
								<span class="jobs-details-btn" @click="openModal(order)">Details</span>
							</td>

							<td>
								<h3>{{ getOrderPlacedByCellText(order) }}</h3>
							</td>
							<td v-if="showNameColumn">{{ getOrderNameCellText(order) }}</td>
							<td>
								AddressOne : {{ order['deliveryAddress']['addressOne'] }}<br>
								AddressTwo : {{ order['deliveryAddress']['addressTwo'] }}<br>
								City : {{ order['deliveryAddress']['city'] }}<br>
								County : {{ order['deliveryAddress']['county'] }}<br>
								Country : {{ order['deliveryAddress']['country'] }}<br>
							</td>							
							<!-- <td>{{ (order.items[0].product ? order.items[0].product.productName : order.items[0].quote_id.quotesProduct) + ',' + (order.items[0].product ? order.items[0].product.productDesc : order.items[0].quote_id.suppliersDesription) }}</td> -->
							<td style="max-width: 400px; min-width: 300px;">
								<div style="width: 100%;">
									<span v-if="isExpanded(order._id)">
										<!-- Add max-height and overflow for scrollable description -->
										<div style="max-height: 150px; overflow-y: auto; overflow-x: hidden; padding-right: 5px; word-wrap: break-word; white-space: normal;">
											<span v-html="getDescription(order).replace(/\n/g, '<br>')"></span>
										</div>
										<a href="#" v-if="isLongDescription(order)"
											@click.prevent="toggleDescription(order._id)"
											style="display: inline-block; margin-top: 5px; color: blue; text-decoration: underline;">See less</a>
									</span>
									<span v-else>
										<div style="word-wrap: break-word; white-space: normal;">
											<span v-html="getShortDescription(order).replace(/\n/g, '<br>')"></span>
										</div>
										<a href="#" v-if="isLongDescription(order)"
											@click.prevent="toggleDescription(order._id)"
											style="display: inline-block; margin-top: 5px; color: blue; text-decoration: underline;">See more</a>
									</span>
								</div>
							</td>
							<td>{{ order.items[0].quantity.quantity }}</td>
							<td>
								{{ getDisplayStatus(order) }}
							</td>
							<!-- <td>{{ order.items[0].product.product.nonPrint == 'Non Print' && order.status == 'Artwork Approved' ? 'Order Approved' : order.status }}</td> -->

							<td>{{ new Date(order.createdAt).toDateString() }}</td>
							<td>
								<template v-if="order.status == 'Order Completed & Shipped' || order.status == 'Order Completed and Shipped'">
									<a v-if="order.items[0].quote_id"
										:href="'/single-product/' + order.items[0].quote_id._id" title="product"
										class="product-name">Re-order</a>
									<a :href="'/custom-product/re-order/' + order._id" title="product" class="product-name"
										v-else>Re-order</a>
								</template>
								<span v-else class="text-muted">-</span>
							</td>
							<!-- <td class="link" @click="reOrderItem(order)">Re-order</td> -->
							<!-- 							
							<td v-if="order.approvedAt">{{ new Date(order.approvedAt).toDateString() }}</td>
							<td v-else> Waiting Approval </td> -->
							<!-- 
							<td v-if="order.deliveryAt">{{ new Date(order.deliveryAt).toDateString() }}</td>
							<td v-else>Not Assigned</td> -->
							<!-- <td v-if="order.dueOn">{{ new Date(order.dueOn).toDateString() }}</td>
							<td v-else>Not Assigned</td> -->
							<!-- <td>Order Delivery Address</td> -->
							<!-- <td> <span v-if="order.deliveryAt">{{ new Date(order.deliveryAt).toDateString() }}</span> </td> -->
							<!-- <td>{{ order.paymentMethod }}</td> -->
							<!-- <td>{{ order.shippingMethod }}</td> -->
							<!-- <td>{{ order.status }}</td> -->
						</tr>
						</tbody>
					</table>
					</div>
					<div class="pagination-controls" v-if="filteredUsOrders && filteredUsOrders.length > perPage">
						<button class="btn btn-primary" @click="prevPage" :disabled="currentPage === 1">Previous</button>
						<span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span>
						<button class="btn btn-primary" @click="nextPage" :disabled="currentPage === totalPages">Next</button>
					</div>

				</div>

			</section>
			</div>
			<!-- Cart main content : End -->
			<!--Cart right banner: Begin-->
			<footer-section></footer-section>
			<div class="modal-mask" v-if="orderDetails == true">
				<div class="modal-wrapper">
					<div class="modal-container">


						<div class="modal-body">
							<button class="btn btn-danger close-btn" style="float:right;" @click="closeModal">
								<b>&#10006;</b>
							</button>
							<h3 class="branch-title" style="text-align: center; font-weight: bold;"><span
									class="icon icon-one"></span>ORDERS/JOBS Details</h3><br>
							<div v-if="!user.isSubChildUser" style="margin: 20px 0;">
								<h3 class="text-left acc-title lg" >User Details</h3><br>
								<table class="table-cart table" style="margin: auto;">
									<tr>
										<th style="padding:0px 20px;">ID</th>
										<th>Name</th>
										<th>Business Name</th>
										<th>Email</th>
									</tr>
									<tr>								
										<td>{{ getOrderUserDetails(selectedOrderNumber).userCode }}</td>
										<td>{{ getOrderUserDetails(selectedOrderNumber).name }} {{ getOrderUserDetails(selectedOrderNumber).lastName }}</td>
										<td>{{ getOrderUserDetails(selectedOrderNumber).accountTitle }}</td>
										<td>{{ getOrderUserDetails(selectedOrderNumber).email }}</td>
									</tr>

								</table>
							</div>

							<h3 class="text-left acc-title lg" >Order Place</h3><br>
							<div class="row">
								<div class="col-lg-6">
									<h3 class="branch-title" style="font-weight: bold;"><span
											class="icon icon-one"></span>Delivery
										Address</h3><br>
									AddressOne : {{ selectedOrderNumber['deliveryAddress']['addressOne'] }}<br>
									AddressTwo : {{ selectedOrderNumber['deliveryAddress']['addressTwo'] }}<br>
									City : {{ selectedOrderNumber['deliveryAddress']['city'] }}<br>
									County : {{ selectedOrderNumber['deliveryAddress']['county'] }}<br>
									Country : {{ selectedOrderNumber['deliveryAddress']['country'] }}<br>
								</div>
								<div class="col-lg-6">
									<h3 class="branch-title" style="font-weight: bold;"><span
											class="icon icon-one"></span>Billing
										Address</h3><br>
									AddressOne : {{ selectedOrderNumber['billingAddress']['billAddressOne'] ?
										selectedOrderNumber['billingAddress']['billAddressOne'] :
										selectedOrderNumber['billingAddress']['addressOne'] }}<br>
									AddressTwo : {{ selectedOrderNumber['billingAddress']['billAddressTwo'] ?
										selectedOrderNumber['billingAddress']['billAddressTwo'] :
										selectedOrderNumber['billingAddress']['addressTwo'] }}<br>
									City : {{ selectedOrderNumber['billingAddress']['billCity'] ?
										selectedOrderNumber['billingAddress']['billCity'] :
										selectedOrderNumber['billingAddress']['city'] }}<br>
									County : {{ selectedOrderNumber['billingAddress']['billCounty'] ?
										selectedOrderNumber['billingAddress']['billCounty'] :
										selectedOrderNumber['billingAddress']['county'] }}<br>
									Country : {{ selectedOrderNumber['billingAddress']['billCountry'] ?
										selectedOrderNumber['billingAddress']['billCountry'] :
										selectedOrderNumber['billingAddress']['country'] }}<br>
								</div>
							</div>
							<br>
							<h3 class="text-left acc-title lg" >Order History</h3><br>
							<template v-if="orderActivs[selectedOrderNumber['orderNumber']]?.length > 0">
								<table>
									<tr v-for="ordAct in orderActivs[selectedOrderNumber['orderNumber']]"
									:key="ordAct._id">
									<td>
										<p class="item-details sec">
											<span class="first">
												<b>
													{{ ordAct.title === "Order Created" ? "Order Created" :
													ordAct.title }}
												</b>
											</span>
											<span class="second">
												{{ ordAct.title === "Order Created" ? "Order Created" : ordAct.title }}
												at {{ new Date(ordAct.createdAt).toDateString()
												}}
											</span>
										</p>
									</td>
								</tr>
								</table>
							</template>
							<template v-else>
								<tr>
									<!-- Handle the case when orderActivs[selectedOrderNumber['orderNumber']] is undefined -->
									<td>
										<p class="item-details sec">
											<span class="first"><b>{{ selectedOrderNumber['status'] }}</b></span>
										</p>
									</td>
								</tr>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import NavBarHome from "@/components/NavBarHome.vue"
import DashboardStats from "./DashboardStats.vue"
import FooterSection from "@/components/FooterSection.vue"
import { mapState } from 'vuex'
export default {
	components: { DashboardStats, NavBarHome, FooterSection },
	methods: {
		nextPage() {
			if (this.currentPage < this.totalPages) {
				this.currentPage++;
			}
		},
		prevPage() {
			if (this.currentPage > 1) {
				this.currentPage--;
			}
		},
		computeItemTotal(item) {
			if (!item) return (0).toFixed(2);
			const base = Number(item.quantity?.sellingProductPrice || 0);
			const vat = Number(item.vat || 0);
			const total = this.$calculateItemTotal(base, [
				item.discountPromoCodeAm,
				item.discountPCPAm,
				item.spendDiscountAm,
			], vat);
			return Number(total).toFixed(2);
		},
		viewArtWorkCondi(value) {
			const productNonPrint = value.items[0].product 
				? value.items[0].product.product?.nonPrint 
				: value.items[0].quote_id?.productProcess;

			return productNonPrint !== "Non Print";
		},
		hasCompletedAndShipped(activities) {			
			if (!Array.isArray(activities)) return false;

			let a= activities.some(a =>
				a?.title === 'Order Completed & Shipped' ||
				a?.title === 'Order Completed and Shipped'
			);
			
			return activities.some(a =>
				a?.title === 'Order Completed & Shipped' ||
				a?.title === 'Order Completed and Shipped'
			);
		},
		downloadFile(fileUrl, fileName) {
			fetch(fileUrl)
				.then(response => response.blob())
				.then(blob => {
					const url = URL.createObjectURL(blob);
					const link = document.createElement('a');
					link.href = url;
					link.download = fileName;
					link.click();
					URL.revokeObjectURL(url);
				})
				.catch(error => console.error('Error:', error));
		},
		artworkStatus(value){
			this.selectArtworkValue = value;
		},

		getDescription(order) {
			const productName = order.items[0].product ? order.items[0].product.product.productName : '';
			const productDesc = order.items[0].product ? order.items[0].product.product.productMktDesc : order.items[0].quote_id.suppliersDesription;
			return order.items[0].quote_id ? productName + ' ' + productDesc : productName + ', ' + productDesc;
		},
		getShortDescription(order) {
			const description = this.getDescription(order);
			const words = description.split(' ');
			if (words.length > 10) {
				return words.slice(0, 10).join(' ') + '...';
			}
			return description;
		},
		toggleDescription(orderId) {
			this.$set(this.expandedDescriptions, orderId, !this.expandedDescriptions[orderId]);
		},
		isExpanded(orderId) {
			return !!this.expandedDescriptions[orderId];
		},
		isLongDescription(order) {
			const description = this.getDescription(order);
			const words = description.split(' ');
			return words.length > 10;
		},

		async startUploadArt(item) {
			if(this.selectArtworkValue == null){
				alert('Please select ‘Yes or No’ - Do you Require an Artwork PDF Proof File')
				return;
			}
			if (this.allFiles == null || this.allFiles == '') {
				alert('Please select Artwork File')
				return;
			}
			
			if (this.allFiles !== null && this.allFiles != '') {
				let name = Date.now() + this.allFiles.name
				const formData = new FormData();
				formData.append('encType', 'multipart/form-data');

				formData.append('artworks', this.allFiles, name)
				console.log(formData)
				//   let DD = Date.now()
				let dec = await this.$store.dispatch("uploadFilesArtworks", formData)
				//   if (dec.status) { 
				// item.artworkSamples.push(name)
				// let supplierEmail = this.selectedItem.items[0].product.product.supplierEmail
				let supplierEmail = this.selectedItem.items[0].product ? this.selectedItem.items[0].product.product.supplierEmail : this.selectedItem.items[0].quote_id.supplierEmail;
				
				let artworkProofing = this.selectArtworkValue;

				await this.$store.dispatch('updateArtowrkData', { item, name, order: this.selectedItem, supplierEmail, artworkProofing })
				this.selectedItem.artworkComment = ''
				this.selectedItem.status = 'Artwork Proofing'
				this.selectedItem.items[0].artwork = name
				this.selectArtworkValue = null
				//update order artwork status
				// clear artowrk comment
				// update order artwork iten name on cartitem
				this.$store.dispatch("getUser")
				this.allFiles = null;
				setTimeout(() => {
					this.$store.state.uploadProgress = 0
				}, 1000);

			}
			// }

		},

		async startUpload(item) {
			if (this.allFiles !== null) {
				const formData = new FormData();
				formData.append('encType', 'multipart/form-data');
				let name = Date.now() + '.' + this.allFiles.type.replace(/(.*)\//g, '')
				formData.append('artworksattach', this.allFiles, name)
				//   formData.append('file', file, Date.now()+'.'+this.allFiles.type.replace(/(.*)\//g, ''));
				console.log(formData)
				let dec = await this.$store.dispatch("uploadFilesArtworksAttach", formData)
				if (dec.status) {
					item.artworkSamples.push(name)
					await this.$store.dispatch('updateArtowrkSamples', { item })
					this.$store.dispatch("getUser")
					this.allFiles = null;
					setTimeout(() => {
						this.$store.state.uploadProgress = 0
					}, 1000);

				}
			}

		},

		handle(event) {
			// this.images = []
			this.allFiles = null
			this.allFiles = event.target.files[0]
			console.log(event, this.allFiles)
			const reader = new FileReader();
			reader.readAsDataURL(this.allFiles);
			reader.onload = () => {
				// this.images.push(reader.result)
			};

			// this.allFiles.forEach((element) => {

			// })


		},

		async updateCEmail() {
			if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.cEmailValue)) {
				let dec = await this.$store.dispatch("updateOrderEmail", { email: this.cEmailValue, order: this.selectedItem.orderNumber })
				if (dec.status) {
					this.$store.dispatch("getUser")

					this.cEmailSuccess = "Order Notification Email has Been Updated."
					this.selectedItem.orderEmail = this.cEmailValue
					setTimeout(() => {
						this.cEmail = false;
					}, 2000);
				}
			} else {
				this.cEmailError = "Invalid Email, Please provide a valid Email"
			}
		},
		changeEmail() {
			let email = { email: this.selectedItem.orderEmail }
			let mail = JSON.stringify(email)
			mail = JSON.parse(mail)
			this.cEmailValue = mail.email;
			this.cEmail = true;
		},
		getOrderUserName(order) {
			const subChildUser = Array.isArray(order?.isSubChildID) && order.isSubChildID.length > 0 && order.isSubChildID[0] !== '' ? order.isSubChildID[0] : null;
			if (subChildUser && typeof subChildUser === 'object') {
				return subChildUser.username || subChildUser.name || subChildUser.email || '';
			}
			if (order?.user && typeof order.user === 'object') {
				return order.user.username || order.user.name || order.user.email || '';
			}
			return this.user?.username || this.user?.name || this.user?.email || '';
		},
		getOrderUserDetails(order) {
			const subChildUser = Array.isArray(order?.isSubChildID) && order.isSubChildID.length > 0 && order.isSubChildID[0] !== '' ? order.isSubChildID[0] : null;
			const orderUser = order?.user && typeof order.user === 'object' ? order.user : null;
			const fallbackUser = this.user || {};
			const sourceUser = subChildUser || orderUser || fallbackUser;

			return {
				userCode: sourceUser?.userCode || sourceUser?.code || '',
				name: sourceUser?.name || '',
				lastName: sourceUser?.lastName || '',
				accountTitle: sourceUser?.accountTitle || sourceUser?.businessName || '',
				email: sourceUser?.email || '',
			};
		},
		// Same Customer Type 1 (ISCPA) / Customer Type 2 (HQ / Head Office vs
		// Branch) mapping used in the admin dashboard's customers table.
		getOrderUserRoleLabel(order) {
			const subChildUser = Array.isArray(order?.isSubChildID) && order.isSubChildID.length > 0 && order.isSubChildID[0] !== '' ? order.isSubChildID[0] : null;
			const orderUser = order?.user && typeof order.user === 'object' ? order.user : null;
			const sourceUser = subChildUser || orderUser || this.user || {};
			if (sourceUser.isUserType === 'dentalcare' || sourceUser.isParentID) {
				return sourceUser.isSubChildUser ? 'Branch' : 'HQ / Head Office';
			}
			return 'ISCPA';
		},
		// Customer Type 2 (HQ / Head Office, Branch) keeps showing that label.
		// Customer Type 1 (ISCPA) has no meaningful type label, so show the
		// customer's name in this column instead of the literal "ISCPA".
		getOrderPlacedByCellText(order) {
			const role = this.getOrderUserRoleLabel(order);
			if (role === 'ISCPA') {
				const details = this.getOrderUserDetails(order);
				return [details.name, details.lastName].filter(Boolean).join(' ');
			}
			return role;
		},
		// ISCPA rows already show the name in the Order Placed By column above,
		// so leave the Name column blank there to avoid showing it twice.
		// HQ / Head Office and Branch rows show the actual person's name here.
		getOrderNameCellText(order) {
			if (this.getOrderUserRoleLabel(order) === 'ISCPA') return '';
			return (order.user.name + order.user.lastName) ? (order.user.name + ' ' + order.user.lastName) : order.isSubChildID[0].name;
		},
		getDisplayStatus(order) {
			const item = order.items[0];
			const isNonPrint = item.product ? item.product.product.nonPrint == 'Non Print' : item.quote_id.productProcess == 'Non Print';
			return (isNonPrint && order.status == 'Artwork Approved') ? 'Order Approved' : order.status;
		},
		getOrderPlacedByText(order) {
			const details = this.getOrderUserDetails(order);
			const accountTitle = order.user?.accountTitle || order.isSubChildID?.[0]?.accountTitle || '';
			return [this.getOrderUserRoleLabel(order), details.name, details.lastName, accountTitle, details.email]
				.filter(Boolean).join(' ');
		},
		openModal(order) {
			this.orderDetails = true;
			this.selectedOrderNumber = order;
			document.body.style.overflow = "hidden";
			document.body.style.position = "fixed";
			document.body.style.width = "100%";
		},
		closeModal() {
			this.orderDetails = false;
			this.selectedOrderNumber = null;
			document.body.style.overflow = "";
			document.body.style.position = "";
			document.body.style.width = "";
		},
		reOrderItem(order) {
			tab = 2;
		},
		async refresh() {
			this.selectedItem = null;
			this.tab = 0;

		},
		formatDateTime(date) {
			if (!date) return ''; // Handle null or undefined date
			const dateObj = new Date(date); // Ensure it's a Date object
			if (isNaN(dateObj)) return 'Invalid Date'; // Handle invalid dates

			return dateObj.toLocaleString('en-GB', { // Keep en-GB for 24-hour support
				weekday: 'short', 
				month: 'short', 
				day: '2-digit', 
				year: 'numeric', 
				hour: '2-digit', 
				minute: '2-digit', 
				second: '2-digit', 
				hour12: true, // Keeps 24-hour format
				timeZone: 'UTC' // Forces display in UTC (which matches original time)
			}).replace(',', ''); // Removes extra comma
		}

	},
	computed: {
		...mapState(['userOrders', 'user', 'orderActivs', 'jobId']),
		usOrders() {
			return this.userOrders.filter(element => {
				return element.items.length > 0 &&
					element.items[0].product !== null &&
					element.items[0].quote_id !== null;
			});
		},
		filteredUsOrders() {
			const query = this.searchQuery.trim().toLowerCase();
			if (!query) return this.usOrders;

			return this.usOrders.filter(order => {
				const orderNo = String(order.orderNumber || '').toLowerCase();
				const placedBy = this.getOrderPlacedByText(order).toLowerCase();
				const addr = order.deliveryAddress || {};
				const branchLocation = [addr.addressOne, addr.addressTwo, addr.city, addr.county, addr.country]
					.filter(Boolean).join(' ').toLowerCase();
				const description = this.getDescription(order).toLowerCase();
				const status = this.getDisplayStatus(order).toLowerCase();

				return orderNo.includes(query) ||
					placedBy.includes(query) ||
					branchLocation.includes(query) ||
					description.includes(query) ||
					status.includes(query);
			});
		},
		// Only Customer Type 2 (HQ / Head Office, Branch) orders have a separate
		// person name to show. Hide the whole Name column when none of this
		// user's orders are Customer Type 2, instead of showing an empty column.
		showNameColumn() {
			return this.usOrders.some(order => this.getOrderUserRoleLabel(order) !== 'ISCPA');
		},
		totalPages() {
			return Math.max(1, Math.ceil(this.filteredUsOrders.length / this.perPage));
		},
		paginatedUsOrders() {
			if (!this.filteredUsOrders || this.filteredUsOrders.length <= 0) return [];
			const start = (this.currentPage - 1) * this.perPage;
			const end = start + this.perPage;
			return this.filteredUsOrders.slice(start, end);
		},
	},
	watch: {
		usOrders() {
			if (this.currentPage > this.totalPages) {
				this.currentPage = 1;
			}
		},
		searchQuery() {
			this.currentPage = 1;
		}
	},

	beforeDestroy() {
		document.body.style.overflow = "";
		document.body.style.position = "";
		document.body.style.width = "";
	},

	async mounted() {
		let jobID = this.$route.params.id;
		if (jobID) {
			try {
				let selectedUserData = await this.$store.dispatch("getJobById", { id: this.$route.params.id });
				this.selectedItem = selectedUserData[0];
				this.tab = 2;
			} catch (error) {
				console.error("Error fetching job by ID:", error);
			}
		}

		this.$store.dispatch("getUser");
	},
	data() {
		return {
			selectedItem: null,
			tab: '',
			// images:[],
			allFiles: null,
			expandedDescriptions: {},
			cEmail: false,
			cEmailValue: '',
			cEmailError: '',
			cEmailSuccess: '',
			orderDetails: false,
			selectedOrderNumber: null,
			selectArtworkValue: null,
			currentPage: 1,
			perPage: 10,
			searchQuery: '',
		}
	}
}
</script>

<style>
.tabs {
	margin: 13px 0px;
	border-bottom: 1px solid lightgray;
	padding: 5px 0px;
}

.tab {
	color: red;
	padding: 5px 25px;
	cursor: pointer;
}

.selected {
	border-bottom: 4px solid red;
}

.link {
	color: blue;
	font-weight: 800;
}

.item-details .first {
	display: inline-block;
	width: 160px;
}

.item-details {
	padding: 11px 4px;
	margin: 0px;
}

.sec {
	background: aliceblue;
}

.head {
	background: #fd5b4e;
}

.v-input {
	position: absolute;
	z-index: 9999;
	height: 100%;
	border: 2px solid red;
	width: 100%;
	opacity: 0;
}

.atstatus {
	background: #282827;
	color: #FFF;
	font-weight: 600;
	display: block;
	width: 545px;
	max-width: 100%;
	padding: 9px 11px;
}

.title {
	font-size: 32px;
	font-weight: 700;
}

.subtitle {
	font-size: 23px;
	font-weight: 500;
}

.modal-mask {
	position: fixed;
	z-index: 999899989998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}

.modal-wrapper {
	display: table-cell;
	vertical-align: middle;
}

.modal-container {
	max-width: 1200px;
	margin-left: auto;
	margin-right: auto;
	/* margin: 0px auto; */
	padding: 1px 0px;
	background-color: #fff;
	border-radius: 2px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
	transition: all 0.3s ease;
	font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
	margin-top: 0;
	color: #42b983;
}

.modal-body {
	margin: 0px 0;
	max-height: 90vh;
    overflow: auto;
}

.modal-default-button {
	float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
	opacity: 0;
}

.modal-leave-active {
	opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}

.close-btn {
	padding: 3px 7px;
	font-size: 12px;
	line-height: 1.5;
	border-radius: 3px;
}

.jobs-tabs {
	margin: 20px 0;
}

.jobs-email {
	margin-bottom: 10px;
}

.color-red {
	color: #fd5b4e;
}
/* .c-table > tr > th{ padding:10px; font-weight:600; font-size:14px;} */
/* .c-table > tr > td{ padding:10px; font-size:14px;} */

@media (max-width: 768px){
	.row{
		padding: 0 15px;
	}
	.calculate-spend{
		margin-top: 10px;
	}
	.row.db-content{
		overflow: auto;
		text-wrap: nowrap;
	}
	a.product-name{
		font-size: 15px;
		padding: 10px;
	}
	    
	.row.db-content {
        overflow: auto;
        text-wrap: nowrap;
    }
	.jobs-tabs .tabs {
		flex-wrap: nowrap;
		display: flex;
		max-width: 100%;
		overflow: auto;
	}

	.jobs-tabs .tab {
		min-width: fit-content;
	}

	.jobs-tabs .tab.selected {
		position: sticky;
		left: -1px;
		background: #fff;
	}

	.jobs-toolbar {
		flex-direction: column;
		align-items: stretch;
	}

	.jobs-search {
		max-width: 100%;
	}
}

section.cart-main span{
	color:#000;
}
section.cart-main .link{
  color: #000;
}
.table-cart th{
  padding: 0px 10px;
}
table{
	width:100%;
}
.table-cart.table tr td a{
	color:blue;
}
@media(max-width:768px){
	    .user-dashboard-menuWrap .c-icon {
        margin-left: 28%;
        margin-top: 11%;
    }
	
}

@media(max-width:550px){
	    .user-dashboard-menuWrap .c-icon {
        margin-left: 33%;
        margin-top: 16%;
    }
}
.jobs-toolbar {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	margin: 18px 0 14px;
}

.jobs-search {
	position: relative;
	flex: 1 1 380px;
	max-width: 480px;
}

.jobs-search-icon {
	position: absolute;
	left: 16px;
	top: 50%;
	transform: translateY(-50%);
	color: #b3b3b3;
	font-size: 14px;
	pointer-events: none;
}

.jobs-search-input {
	width: 100%;
	padding: 11px 40px;
	border: 1px solid #e3e3e3;
	border-radius: 30px;
	font-size: 14px;
	font-family: inherit;
	outline: none;
	background: #fff;
	box-sizing: border-box;
	transition: border-color .2s ease, box-shadow .2s ease;
}

.jobs-search-input:focus {
	border-color: #fd5b4e;
	box-shadow: 0 0 0 3px rgba(253, 91, 78, 0.15);
}

.jobs-search-clear {
	position: absolute;
	right: 10px;
	top: 50%;
	transform: translateY(-50%);
	border: none;
	background: transparent;
	color: #b3b3b3;
	cursor: pointer;
	font-size: 13px;
	padding: 6px;
	line-height: 1;
}

.jobs-search-clear:hover {
	color: #fd5b4e;
}

.jobs-result-count {
	font-size: 13px;
	color: #777;
	font-weight: 600;
	white-space: nowrap;
}

.jobs-table-wrap {
	margin: 0 0 20px;
	overflow: auto;
	text-wrap: nowrap;
	background: #fff;
	border-radius: 10px;
	box-shadow: 0 2px 14px rgba(0, 0, 0, 0.08);
	border: 1px solid #eee;
}

.jobs-table {
	margin: 0 !important;
}

.jobs-table th,
.jobs-table td {
	text-align: left !important;
	vertical-align: middle !important;
}

.jobs-table th:nth-child(7),
.jobs-table th:nth-child(8),
.jobs-table th:nth-child(9),
.jobs-table th:nth-child(10),
.jobs-table td:nth-child(7),
.jobs-table td:nth-child(8),
.jobs-table td:nth-child(9),
.jobs-table td:nth-child(10) {
	text-align: center !important;
}

.jobs-table th {
	background: #fff5f4;
	color: #3a3a3a;
	text-transform: uppercase;
	font-size: 12px;
	letter-spacing: .04em;
	font-weight: 700;
	padding: 14px 20px !important;
	white-space: nowrap;
	border: none !important;
	border-bottom: 2px solid #fd5b4e !important;
}

.jobs-table td {
	padding: 16px 20px !important;
	font-size: 14px;
	line-height: 1.6;
	border-bottom: 1px solid #f0f0f0;
}

.jobs-table tbody tr:last-child td {
	border-bottom: none;
}

.jobs-table tbody tr:nth-child(even) {
	background: #fafbfc;
}

.jobs-table tbody tr:hover {
	background: #fff4f2;
}

.jobs-details-btn {
	display: inline-block;
	padding: 5px 16px;
	border-radius: 20px;
	background: #fff0ee;
	color: #fd5b4e !important;
	font-weight: 700;
	font-size: 12px;
	text-transform: uppercase;
	letter-spacing: .03em;
	cursor: pointer;
	transition: background .2s ease, color .2s ease;
}

.jobs-details-btn:hover {
	background: #fd5b4e;
	color: #fff !important;
}

.jobs-no-results {
	text-align: center;
	padding: 46px 20px !important;
	color: #999;
	font-size: 15px;
	white-space: normal;
}

.jobs-no-results .fa {
	display: block;
	font-size: 28px;
	margin-bottom: 10px;
	color: #ddd;
}

.pagination-controls {
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 20px 0;
	gap: 14px;
}
.pagination-controls button {
	border-radius: 30px;
	padding: 8px 22px;
	text-transform: uppercase;
	font-weight: 600;
	font-size: 13px;
	letter-spacing: .03em;
}
.pagination-controls button:disabled {
	opacity: .45;
	cursor: not-allowed;
}
.page-info {
	margin: 0;
	font-size: 13px;
	font-weight: 600;
	color: #555;
	background: #f5f5f5;
	padding: 6px 16px;
	border-radius: 20px;
}
</style>